// extracted by mini-css-extract-plugin
module.exports = {"container":"i_G2","button":"i_G3"};